export default __webpack_public_path__ + "static/media/foto3.ee8bb669.JPG";